import React from 'react';
const ResponseError = (props) => (props.errorMessage && (React.createElement("div", { className: "alert alert-danger", role: "alert" }, props.errorMessage))) ||
    null;
export default ResponseError;
